module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "copyright-page"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "pageiv"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/L01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("STERLING and the distinctive Sterling logo are registered trademarks of Sterling Publishing Co., Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Compilation © 2017 Linda Picone")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means (including electronic, mechanical, photocopying, recording, or otherwise) without prior written permission from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN 978-1-4549-2783-9")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("For information about custom editions, special sales, and premium and corporate purchases, please contact Sterling Special Sales at 800-805-5489 or "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "mailto:specialsales@sterlingpublishing.com"
    }
  }, [_vm._v("specialsales@sterlingpublishing.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "http://sterlingpublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("sterlingpublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Book design by Christine Heun")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c507b54e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454927839_epub_cop_r1.vue
// module id = 63
// module chunks = 0